import axios from 'axios';
import React, { useEffect } from 'react';
import { alertRef } from '../../../../App';
import { Button } from '../../../../Components/StyledComponents';
import Switch from '../../../../Components/Switch/Switch';
import SetSMS from '../../Components/SetSMS/SetSMS';
import './Point.scss';

/* **** 
    Retention 참고
    **** */

const Point = () => {
    const [ isActive, setIsActive ] = React.useState(false)
    const [ title, setTitle ] = React.useState('');
    const [ text, setText ] = React.useState('');
    const [ coupon, setCoupon ] = React.useState('');
    const [ couponInfo, setCouponInfo ] = React.useState({})
    const [ condition, setCondition ] = React.useState({ Type : '적립'})

    useEffect(() => {
        getAutoSMSInfo()
    },[])

    const getAutoSMSInfo = () => {
        axios.get('/api/auto_sms/Event')
        .then((data) => {
            setTitle(data.data.Title)
            setText(data.data.Body)
            if( data.data.Coupon !== null && typeof data.data.CouponInfo !== 'undefined'){
                setCoupon(data.data.Coupon.$oid)
                setCouponInfo(data.data.CouponInfo)
            }
            setCondition(data.data.Condition)
            setIsActive(data.data.Enable)
        })
    }

    const patchSMS = () => {
        axios.patch('/api/auto_sms/Event')
        .then((data) => {
            alertRef.current.showAlert({ title : `자동 문자가 ${isActive ? '비' : ''}활성화 되었습니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
        .catch(() => {
            setIsActive(old => !old)
            alertRef.current.showAlert({ title : `먼저 문자설정을 진행해주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    const setSMS = () => {
        axios.post('/api/auto_sms',{
            Type : 'Event',
            Title : title,
            Body : text,
            Coupon : coupon,
            Condition : condition
        })
        .then((data) => {
            getAutoSMSInfo()
            alertRef.current.showAlert({ title : `자동 문자가 설정 되었습니다.`, subWarnTitle : '자동문자를 활성화 해주세요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `문자 내용을 확인해주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    return (
        <div className='first'>
            <SetSMS type={'Point'} smsTitle={title} setSMSTitle={setTitle} smsText={text} setSMSText={setText} coupon={coupon} setCoupon={setCoupon} couponInfo={couponInfo} setCouponInfo={setCouponInfo} condition={condition} setCondition={setCondition}/>

            <p className='warn-text'>* 활성화 전에 입력하신 문자 내용을 저장해주세요!</p>
            <div className='row-auto'>
                <p className='active-text'>자동문자 활성화하기</p>
                <Switch id='first' value={isActive} onChange={(val) => {setIsActive(val => !val); patchSMS()}} />
            </div>

            <Button variant='main' disabled={ title.trim() === '' || text.trim() === '' } style={{ width : 173 }} onClick={() => alertRef.current.showAlert({ title : `자동 문자를 설정할까요?`, isConfirm : true, confirmText : '확인', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();setSMS()} })}>
                저장하기
            </Button>
        </div>
    )
}

export default Point;